import { render, staticRenderFns } from "./ServiceWagesAndAllowanceRecord.vue?vue&type=template&id=3078b68e&scoped=true"
import script from "./ServiceWagesAndAllowanceRecord.vue?vue&type=script&lang=js"
export * from "./ServiceWagesAndAllowanceRecord.vue?vue&type=script&lang=js"
import style0 from "./ServiceWagesAndAllowanceRecord.vue?vue&type=style&index=0&id=3078b68e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3078b68e",
  null
  
)

export default component.exports